export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const passwordRegex =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+~`\-={}[\]\\|:;"'<>,.?/])[A-Za-z\d!@#$%^&*()_+~`\-={}[\]\\|:;"'<>,.?/]{6,}$/;

export const validateInputTypeNumberRegex = /^\d*\.?\d*$/;

export const noSpecialCharsNoWhitespaceNoNumbersStartEndRegex =
  /^(?!\s)(?!.*\s{2})[a-zA-Z\s]*$/;

export const noSpecialCharsNoWhitespaceStartEndAndNotAllowCommaRegex =
  /^(?!\s)(?!.*\s{2})[a-zA-Z0-9\s/_|'-]*\w$/;

export const noSpecialCharsNotAllowOnlyNumbers =
  /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z])[\w\s]+$/;
